import React, {useEffect, useRef, useState} from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faBan, faCheckCircle, faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {useSelector} from "react-redux";
import axios from "axios";
import {ProgressSpinner} from "primereact/progressspinner";
import {Toast} from "primereact/toast";


export const PayFastReturn = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [transactionStatus, setTransactionStatus] = useState(null);
    const params = useParams();
    const apiURL = useSelector(state => state.mopriSettings.mopriAPIURL);
    const navigate = useNavigate();
    const myToast = useRef(null);

    useEffect(() => {
        getTransactionStatus()
    }, []);

    const getTransactionStatus = async () => {
        const isGuid = str => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(str);

        if (isGuid(params.id)) {
            if (params.id) {
                const response = await axios.post(`${apiURL}/api/gateway/getPayFastTransactionStatus`, {
                    tid: params.id,
                })
                setTransactionStatus(response.data?.PF_payment_status)
                setIsLoading(false)
            } else {
                myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'Invalid transaction ID supplied.', life: 5000});
                setIsLoading(false)
                setTransactionStatus('INVALID')
            }
        } else {
            myToast.current.show({severity: 'error', summary: 'ERROR', detail: 'Invalid transaction ID supplied.', life: 5000});
            setIsLoading(false)
            setTransactionStatus('INVALID')
        }
    }

    const goBack = () => {
        navigate('/');
    };

    if (!isLoading) {
        if (transactionStatus === 'COMPLETE') {
            return (
                <div className="grid justify-content-center align-items-center bg-green-100">
                    <Toast ref={myToast} />
                    <div className="col-12 md:col-6 lg:col-6">
                        <Card
                            className="shadow-2 surface-card"
                            title={
                                <div className="flex align-items-center" style={{color: 'green'}}>
                                    <FontAwesomeIcon icon={faCheckCircle} className="mr-2 text-green-500 text-2xl"/>
                                    <span className="text-xl font-semibold">Payment Successful</span>
                                </div>
                            }
                        >
                            <div className="mb-4">
                                <img
                                    src="/img/payfast-logo.png"
                                    alt={"PayFast"}
                                    style={{
                                        height: '60px',
                                        width: 'auto',
                                    }}
                                />
                                <p className="mt-2 text-lg text-gray-700">
                                    Your payment was successful!
                                </p>
                                <p className="mt-2 text-lg text-gray-700">
                                    Your account balance has been updated and should reflect shortly.
                                </p>
                            </div>
                            <div className="mb-4 text-gray-600">
                                <p>Thank you for your top-up.</p>
                            </div>
                            <div className="flex justify-content-end">
                                <Button label="Go to Dashboard" icon="pi pi-user" className="p-button-success"
                                        onClick={goBack}/>
                            </div>
                        </Card>
                    </div>
                </div>
            );
        } else if (transactionStatus === 'INVALID') {
            return (
                <div className="grid justify-content-center align-items-center bg-gray-100">
                    <Toast ref={myToast} />
                    <div className="col-12 md:col-6 lg:col-6">
                        <Card>
                            <div className="flex justify-content-center">
                                <h3>Invalid transaction ID, please contact support.</h3>
                            </div>
                        </Card>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="grid justify-content-center align-items-center bg-gray-100">
                    <Toast ref={myToast} />
                    <div className="col-12 md:col-6 lg:col-6">
                        <Card
                            className="shadow-2 surface-card"
                            style={{marginTop: '0', paddingTop: '2rem'}}
                            title={
                                <div className="flex align-items-center" style={{color: 'red'}}>
                                    <FontAwesomeIcon icon={faTimesCircle} className="mr-2 text-red-500 text-2xl"/>
                                    <span className="text-xl font-semibold">Payment Declined</span>
                                </div>
                            }
                        >
                            <div className="mb-4">
                                <img
                                    src="/img/payfast-logo.png"
                                    alt={"PayFast"}
                                    style={{
                                        height: '60px',
                                        width: 'auto',
                                    }}
                                />
                                <p className="mt-2 text-lg text-gray-700">
                                    We're sorry, but your payment was declined or encountered an error.
                                </p>
                                <p className="mt-2 text-lg text-gray-700">
                                    Your account balance has not been updated.
                                </p>
                            </div>
                            <div className="mb-4 text-gray-600">
                                <p>Please double-check your payment details and try again.</p>
                                <p>If the issue persists, you may want to contact your bank or try a different payment
                                    method.</p>
                            </div>
                            <div className="flex justify-content-end">
                                <Button label="Try Again" icon="pi pi-refresh" className="p-button-warning mr-2"
                                        onClick={goBack}/>
                            </div>
                        </Card>
                    </div>
                </div>
            );
        }
    } else {
        return (
            <div className="grid justify-content-center align-items-center bg-gray-100">
                <Toast ref={myToast} />
                <div className="col-12 md:col-6 lg:col-6">
                    <Card>
                        <div className="flex justify-content-center">
                            <ProgressSpinner />
                        </div>
                    </Card>
                </div>
            </div>
        )
    }
};